
import React from 'react'
import { Form, Input } from 'antd'
import styles from './antdPassInput.module.css'

const AntdPassInput = ({name,label,rules, placeholder})=> {
    return (
        <>
        <Form.Item  labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} name={name} label={<label className={styles.label_style}>{label}</label>} rules={rules} >
            <Input.Password className={styles.Pass_input} style={{border:'2px solid white'}} placeholder={placeholder}/>
        </Form.Item>
        </>
    )
}

export default AntdPassInput